<template>
  <div>
    <v-dialog :value="open" max-width="750" @click:outside="close">
      <v-card class="background-voucher">
        <v-form v-on:submit.prevent="sendEmail">
          <v-card-title class="headline mb-4">{{ title }}</v-card-title>
          <v-card-text>
            <div class="row">
              <div class="col-md-12 pt-0 pb-0">
                <v-text-field
                  persistent-hint
                  hint='Si queres escribir mas de un correo separarlo con ","'
                  data-vv-as="Para"
                  label="Para"
                  name="to"
                  v-model="send_email.to"
                  v-validate="'required'"
                ></v-text-field>
                <span class="red--text">{{ errors.first("to") }}</span>
              </div>
              <div class="col-md-12 pt-0 pb-0">
                <v-text-field data-vv-as="Responder a" label="Responder a" name="reply" v-model="send_email.reply" v-validate="'email|required'"></v-text-field>
                <span class="red--text">{{ errors.first("reply") }}</span>
              </div>
              <div class="col-md-12 pt-0 pb-0">
                <v-text-field data-vv-as="Asunto" label="Asunto" name="subject" v-model="send_email.subject" v-validate="'required'"></v-text-field>
                <span class="red--text">{{ errors.first("subject") }}</span>
              </div>
              <div class="col-md-12 pt-0 pb-0">
                <div class="d-flex align-center mb-2">
                  <v-chip style="border: 1px solid #2e3d45" class="mr-2">Adjunto: {{ this.cbte_number }}</v-chip>
                  <v-btn small color="primary" outlined @click="openSelectVouchersDialog">
                    <v-icon small left>mdi-plus</v-icon>
                    Agregar más comprobantes
                  </v-btn>
                </div>
                
                <!-- Comprobantes adicionales seleccionados -->
                <div v-if="additionalVouchers.length > 0" class="mt-2">
                  <div class="text-caption grey--text mb-1">Comprobantes adicionales:</div>
                  <v-chip
                    v-for="voucher in additionalVouchers"
                    :key="voucher.id"
                    close
                    class="ma-1"
                    color="primary"
                    outlined
                    @click:close="removeAdditionalVoucher(voucher)"
                  >
                    {{ voucher.voucher_number_label }}
                  </v-chip>
                </div>
              </div>
              <div class="col-md-12 pt-0 pb-0 mb-4">
              </div>
              <div class="col-md-12 pt-0 pb-0">
                <v-textarea data-vv-as="Mensaje" label="Mensaje" name="message" v-model="send_email.message"></v-textarea>
                <span class="red--text">{{ errors.first("message") }}</span>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="close">Cancelar</v-btn>
            <v-btn color="green darken-1" text type="submit" :loading="loading">Enviar Email</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <DialogLoading :dialog="dialog_loading" text="Cargando..." />
    <DialogSelectVouchers 
      :open="dialog_select_vouchers" 
      @closeDialog="closeSelectVouchersDialog"
      :currentVoucherId="item ? item.id : null"
      :clientId="item && item.receiver && item.receiver.client ? item.receiver.client.id : null"
      :alreadySelected="additionalVouchers"
      @vouchersSelected="onVouchersSelected"
    />
  </div>
</template>

<script>
import DialogLoading from "@/components/DialogLoading.vue";
import DialogSelectVouchers from "./DialogSelectVouchers.vue";
import SettingsMixin from "@/mixins/SettingsMixin.vue";
import { sendEmailService } from "../../../libs/ws/sendEmailService";

export default {
  components: { DialogLoading, DialogSelectVouchers },
  mixins: [SettingsMixin],
  props: {
    title: String,
    open: Boolean,
    isViewModal: {
      default: false,
      type: Boolean,
    },
    closeDialog: Function,
    item: Object,
  },
  data: () => ({
    service: sendEmailService,
    loading: false,
    dialog_loading: false,
    dialog_select_vouchers: false,
    send_email: {
      to: "",
      reply: "",
      subject: "",
      message: "",
      type: "voucher",
      object_id: null,
      object_ids: [], // Array de IDs de comprobantes
    },
    cbte_number: "-",
    defaultSendEmail: null,
    additionalVouchers: [], // Comprobantes adicionales seleccionados
  }),
  watch: {
    open(val) {
      this.send_email = JSON.parse(JSON.stringify(this.defaultSendEmail));
      this.additionalVouchers = [];
      this.errors.clear();
      if (this.item) {
        if (this.item.receiver.client.invoiced_email != null) {
          let emailsString = this.item.receiver.client.invoiced_email;
          let emailsArray = emailsString.split(/\s+/);
          //remuevo las comas de los emails
          emailsArray = emailsArray.map((email) => email.replace(/,/g, ""));
          this.send_email.to = emailsArray.join(", ");
        } else {
          this.send_email.to = "";
        }
        this.cbte_number = this.item.pto_vta.toString().padStart(4, "0") + "-" + this.item.voucher_number.toString().padStart(8, "0");
        this.send_email.object_id = this.item.id;
        this.send_email.object_ids = [this.item.id]; // Inicializar con el comprobante actual
        
        // Si config_email está habilitado, reutilizar asunto y mensaje del último email
        if (this.settings.config_email && this.send_email.to) {
          this.loadLastEmailData();
        }
      }
    },
  },
  mounted() {
    this.send_email.reply = this.settings.email_sender;
    this.defaultSendEmail = JSON.parse(JSON.stringify(this.send_email));
  },
  methods: {
    close() {
      this.send_email = JSON.parse(JSON.stringify(this.defaultSendEmail));
      this.additionalVouchers = [];
      this.$emit("closeDialog");
    },
    
    async loadLastEmailData() {
      try {
        // Verificar que tenemos el client_id
        if (!this.item || !this.item.receiver || !this.item.receiver.client || !this.item.receiver.client.id) {
          return;
        }
        
        const client_id = this.item.receiver.client.id;
        const type = this.send_email.type || 'voucher';
        
        const response = await this.service.getLastSentEmail(client_id, type);
        
        if (response.status === true && response.result) {
          // Reutilizar subject y message del último email enviado
          this.send_email.subject = response.result.subject || this.send_email.subject;
          this.send_email.message = response.result.message || this.send_email.message;
        }
      } catch (error) {
        // Si no hay email previo o hay error, simplemente no hacer nada
        // No mostrar error al usuario ya que es opcional
        console.log('No se encontró email previo o hubo un error:', error);
      }
    },
    
    openSelectVouchersDialog() {
      this.dialog_select_vouchers = true;
    },
    
    closeSelectVouchersDialog() {
      this.dialog_select_vouchers = false;
    },
    
    onVouchersSelected(vouchers) {
      // Agregar los vouchers seleccionados que no estén ya en la lista
      vouchers.forEach(voucher => {
        const exists = this.additionalVouchers.find(v => v.id === voucher.id);
        if (!exists) {
          this.additionalVouchers.push(voucher);
        }
      });
      
      // Actualizar array de IDs: comprobante principal + adicionales
      this.send_email.object_ids = [
        this.item.id,
        ...this.additionalVouchers.map(v => v.id)
      ];
    },
    
    removeAdditionalVoucher(voucher) {
      const index = this.additionalVouchers.findIndex(v => v.id === voucher.id);
      if (index > -1) {
        this.additionalVouchers.splice(index, 1);
      }
      
      // Actualizar array de IDs
      this.send_email.object_ids = [
        this.item.id,
        ...this.additionalVouchers.map(v => v.id)
      ];
    },
    
    sendEmail(e) {
      if (this.loading) return;

      this.$validator.validate().then((valid) => {
        if (valid) {
          e.preventDefault();

          // Validar que no haya más de 10 comprobantes en total
          if (this.send_email.object_ids.length > 10) {
            this.$toast.error("No puedes enviar más de 10 comprobantes en un solo email", "Error");
            return;
          }

          this.loading = true;
          this.service
            .create(this.send_email)
            .then((response) => {
              if (response.status == true) {
                const count = this.send_email.object_ids.length;
                this.$toast.success(
                  `El correo electrónico con ${count} comprobante${count > 1 ? 's' : ''} se envió correctamente.`,
                  "OK"
                );
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.$toast.error(response.message, "Error");
                } else {
                  this.$toast.error(response.msg, "Error");
                }
              }
            })
            .catch((response) => {
              this.$toast.error(response.msg, "Error");
            })
            .finally(() => {
              this.loading = false;
              this.close();
            });
        }
      });
    },
  },
};
</script>
